import { render } from "./KubernetesServiceTab.vue?vue&type=template&id=e4a6d828&scoped=true"
import script from "./KubernetesServiceTab.vue?vue&type=script&lang=js"
export * from "./KubernetesServiceTab.vue?vue&type=script&lang=js"

import "./KubernetesServiceTab.vue?vue&type=style&index=0&id=e4a6d828&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a6d828"]])

export default __exports__